export const UPDATE_PHYSICAL_PERSON_ATTEMPT = 'UPDATE_PHYSICAL_PERSON_ATTEMPT';
export type UPDATE_PHYSICAL_PERSON_ATTEMPT = typeof UPDATE_PHYSICAL_PERSON_ATTEMPT;

export const UPDATE_PHYSICAL_PERSON_SUCCESS = 'UPDATE_PHYSICAL_PERSON_SUCCESS';
export type UPDATE_PHYSICAL_PERSON_SUCCESS = typeof UPDATE_PHYSICAL_PERSON_SUCCESS;

export const UPDATE_PHYSICAL_PERSON_FAILURE = 'UPDATE_PHYSICAL_PERSON_FAILURE';
export type UPDATE_PHYSICAL_PERSON_FAILURE = typeof UPDATE_PHYSICAL_PERSON_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/physical-person/update/Types.tsx